"use strict";
function parseSalary(salaryStr) {
    return Number(salaryStr.replace(/[^0-9.-]+/g, ""));
}
function sortList(ulElement) {
    var items = Array.from(ulElement.querySelectorAll("li"));
    items.sort(function(a, b) {
        return parseSalary(b.dataset.salary) - parseSalary(a.dataset.salary);
    });
    items.forEach(function(item) {
        return ulElement.appendChild(item);
    });
}
function getEmployees(ulElement) {
    return Array.from(ulElement.querySelectorAll("li")).map(function(item) {
        var nameElement = item.querySelector(".name");
        return {
            name: nameElement ? nameElement.textContent.trim() : "",
            position: item.dataset.position,
            salary: parseSalary(item.dataset.salary),
            age: Number(item.dataset.age)
        };
    });
}
var employeeList = document.querySelector("ul");
if (employeeList) {
    sortList(employeeList);
    getEmployees(employeeList);
}

//# sourceMappingURL=index.f537644b.js.map
